import { conferenceHasEnded, conferenceHasFailed, leaveConferenceRequest, endConferenceRequest, } from "./actions";
import { mqttEvent, killAllAction } from "../actions";
export function conferenceHasEndedPattern(conferenceId) {
    return (action) => action.type === conferenceHasEnded.toString() &&
        action.payload.conferenceId === conferenceId;
}
export function conferenceHasFailedPattern(conferenceId) {
    return (action) => action.type === conferenceHasFailed.toString() &&
        action.payload === conferenceId;
}
export function mqttEventPattern(conferenceId) {
    return (action) => action.type === mqttEvent.toString() &&
        action.payload.conferenceId === conferenceId;
}
export function leaveConferenceRequestPattern(conferenceId) {
    return (action) => action.type === leaveConferenceRequest.toString() &&
        action.payload.name === conferenceId;
}
export function endConferenceRequestPattern(conferenceId) {
    return (action) => action.type === endConferenceRequest.toString() &&
        action.payload.name === conferenceId;
}
export function killAllPattern() {
    return (action) => action.type === killAllAction.toString();
}
